import { Button } from "@chakra-ui/button"
import { Icon } from "@chakra-ui/icon"
import { Flex } from "@chakra-ui/layout"
import { Menu, MenuButton, MenuList } from "@chakra-ui/menu"
import type { FC, ReactNode } from "react"

import { EllipsisVertical } from "ui/components/icons/font-awesome/EllipsisVertical"

type OptionsMenuProps = {
  children: ReactNode
}

const OptionsMenu: FC<OptionsMenuProps> = ({ children }) => {
  return (
    <Flex>
      <Menu>
        <MenuButton
          as={Button}
          bgColor="white"
          borderColor="gray.300"
          borderWidth="1px"
          px={3}
        >
          <Icon as={EllipsisVertical} fill="gray.600" />
        </MenuButton>
        <MenuList>{children}</MenuList>
      </Menu>
    </Flex>
  )
}

export default OptionsMenu
